import { transformI18n } from '@/lang/index'
export const routerArrays: Array<RouteConfigs> = [
  {
    path: '/index',
    parentPath: '/',
    meta: {
      title: transformI18n('menus.hshome'),
      icon: 'HomeFilled',
    },
  },
]
